module.exports = __webpack_public_path__ + "static/media/logo-no-border.a92468ab.png";